'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.ecs-deploy.production/build/src/node_modules/react/react.js
// module id = nakD
// module chunks = 20